<template>
  <div class="info_tabs_wechat">
    <div class="radio_box">
      <div>模式：</div>
      <div>
        <el-radio v-model="dataMethedList.mode" :label="1">主域名</el-radio>
        <el-radio v-model="dataMethedList.mode" :label="2">随机</el-radio>
      </div>
    </div>
    <div class="radio_box">
      <div>操作：</div>
      <el-button type="primary" size="mini" @click="hideSave" plain>保存</el-button>
    </div>
    <div class="box_chang_info">
      <div>域名：</div>
      <div class="tab_info">
        <div class="tab_head_tou">
          <div class="one_line td_head">序号</div>
          <div class="two_line td_head">域名</div>
          <div class="one_line td_head">主/备</div>
          <div class="one_line last_line td_head">操作</div>
        </div>
        <div class="tab_head_tou" v-for="(item,index) in dataMethedList.urls" :key="index">
          <div class="one_line td_head">{{ index + 1 }}</div>
          <div class="two_line td_head">
            <el-input style="width:90%;height: 100%" v-model="item.url"></el-input>
          </div>
          <div class="one_line td_head">
            <el-switch
                v-model="item.main"
                :active-value="1"
                :inactive-value="0"
                :disabled="item.main==1"
                @change="changeSwitch(item,index)"
            >
            </el-switch>
          </div>
          <div class="one_line td_head last_line" >
            <el-button v-if="deleteShow" @click="delectList(index)" type="danger" plain size="mini" icon="el-icon-delete" circle></el-button>
          </div>
        </div>
        <div v-if="addShow" class="tab_head_tou _tab_add" @click="add_info_tab">
          <i class="el-icon-plus"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "configureList",
  data() {
    return {
      radio: '1',
      loading: false,
      dataMethedList: {
        mode: 1,
        urls: []
      },
      wechat_info: {
        cfgCode: "WECHAT_OAUTH_URL_GROUP",
        cfgId: 26,
        cfgName: "微信授权地址配置",
        cfgSeq: 1,
        cfgStatus: 1,
        cfgVal: {},
        parentId: 0
      },
      listLength: 0,
      click:true,

      addShow:false,
      deleteShow:false
    }
  },
  mounted() {
    this.getConfigList()
    this.getPermissionButtonList()
  },
  methods: {
    getPermissionButtonList() {
      let PermissionButtonList = window.sessionStorage.getItem('TaotanPermissionButton')
      let arr = JSON.parse(PermissionButtonList)
      if (arr.length) {
        arr.map(item => {
          if (item.code == 'wechat:domain:add') {
            this.addShow = true
          }
          if (item.code == "wechat:domain:delete") {
            this.deleteShow = true
          }
        })
      }
    },

    delectList(index){
       this.dataMethedList.urls.splice(index,1)
    },
    add_info_tab() {
      this.click = false
      let obj = {}
      if (this.dataMethedList.urls.length) {
         obj = {
          url: '',
          main: 0,
          status: 0
        }
      } else {
         obj = {
          url: '',
          main: 1,
          status: 0
        }
      }
      this.dataMethedList.urls.push(obj)
    },
    async getConfigList() {
      this.loading = true;
      const {data: resData} = await this.$get("config/info/WECHAT_OAUTH_URL_GROUP");
      this.loading = false;
      if (resData.result != 200) return;
      if(resData.data){
        this.wechat_info = resData.data
        this.dataMethedList = JSON.parse(resData.data.cfgVal)
        this.listLength = this.dataMethedList.urls.length
      }
    },
    async hideSave() {
      this.wechat_info.cfgVal = JSON.stringify(this.dataMethedList)
      let a = ''
      this.dataMethedList.urls.map(item=>{
        if(item.url){
          a = 1
        }
      })
      if(a==1){
        this.loading = true;
        if (this.dataMethedList.urls.length > 1) {
          const {data: resData} = await this.$put("config/info", {
            ...this.wechat_info
          });
          this.loading = false;
          if (resData.result != 200) return;
          this.click = true
          this.$message.success('操作成功')
        } else {
          const {data: resData} = await this.$post("config/info", {
            ...this.wechat_info
          });
          this.loading = false;
          if (resData.result != 200) return;
          this.click = true
          this.$message.success('操作成功')
        }
        this.getConfigList()
      }else {
        this.$message.error('请将域名添加完成后保存')
      }

    },
    changeSwitch(items, indexs) {
      let arr = this.dataMethedList.urls
      arr.map((item, index) => {
        if (index != indexs) {
          item.main = 0
        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.info_tabs_wechat {
  cursor: pointer;

  .radio_box {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
    font-size: 14px;
  }

  .box_chang_info {
    display: flex;
    margin-bottom: 20px;
    font-size: 14px;

    .tab_info {
      border: 1px solid #959595;
      border-bottom: 0;
      background: #ffffff;

      .tab_head_tou {
        display: flex;
        align-items: center;
        box-sizing: border-box;
        border-bottom: 1px solid #959595;

        .td_head {
          text-align: center;
          height: 44px;
          line-height: 44px;
          border-right: 1px solid #959595;
        }

        .one_line {
          width: 80px;
        }

        .two_line {
          width: 280px;
        }

        .last_line {
          border-right: 0;
        }
      }

      ._tab_add {
        height: 44px;
        font-size: 28px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #959595;
      }
    }
  }
}
</style>